<template>
	<div class="bg-white dark:bg-gray-900 shadow-md rounded-md overflow-hidden">
		<div
			class="bg-gray-50 dark:bg-gray-800 border-b border-gray-100 flex items-baseline justify-between py-4 px-6 dark:border-gray-800"
		>
			<h2 class="font-semibold text-lg">Who to follow</h2>
			<a href="#"> Refresh</a>
		</div>

		<div class="divide-gray-300 divide-gray-50 divide-opacity-50 divide-y px-4 dark:divide-gray-800 dark:text-gray-100">
			<div class="flex items-center justify-between py-3">
				<div class="flex flex-1 items-center space-x-4">
					<a href="profile.html">
						<img src="/img/avatar-2.jpeg" class="bg-gray-200 rounded-full w-10 h-10" />
					</a>
					<div class="flex flex-col">
						<span class="block capitalize font-semibold"> Johnson smith </span>
						<span class="block capitalize text-sm"> Australia </span>
					</div>
				</div>

				<a
					href="#"
					class="border border-gray-200 font-semibold px-4 py-1 rounded-full hover:bg-pink-600 hover:text-white hover:border-pink-600 dark:border-gray-800"
				>
					Follow
				</a>
			</div>
			<div class="flex items-center justify-between py-3">
				<div class="flex flex-1 items-center space-x-4">
					<a href="profile.html">
						<img src="/img/avatar-1.jpeg" class="bg-gray-200 rounded-full w-10 h-10" />
					</a>
					<div class="flex flex-col">
						<span class="block capitalize font-semibold"> James Lewis </span>
						<span class="block capitalize text-sm"> Istanbul </span>
					</div>
				</div>
				<a
					href="#"
					class="border border-gray-200 font-semibold px-4 py-1 rounded-full hover:bg-pink-600 hover:text-white hover:border-pink-600 dark:border-gray-800"
				>
					Follow
				</a>
			</div>
			<div class="flex items-center justify-between py-3">
				<div class="flex flex-1 items-center space-x-4">
					<a href="profile.html">
						<img src="/img/avatar-5.jpeg" class="bg-gray-200 rounded-full w-10 h-10" />
					</a>
					<div class="flex flex-col">
						<span class="block capitalize font-semibold"> John Michael </span>
						<span class="block capitalize text-sm"> New York </span>
					</div>
				</div>
				<a
					href="#"
					class="border border-gray-200 font-semibold px-4 py-1 rounded-full hover:bg-pink-600 hover:text-white hover:border-pink-600 dark:border-gray-800"
				>
					Follow
				</a>
			</div>
			<div class="flex items-center justify-between py-3">
				<div class="flex flex-1 items-center space-x-4">
					<a href="profile.html">
						<img src="/img/avatar-7.jpeg" class="bg-gray-200 rounded-full w-10 h-10" />
					</a>
					<div class="flex flex-col">
						<span class="block capitalize font-semibold"> Monroe Parker </span>
						<span class="block capitalize text-sm"> Yeman </span>
					</div>
				</div>

				<a
					href="#"
					class="border border-gray-200 font-semibold px-4 py-1 rounded-full hover:bg-pink-600 hover:text-white hover:border-pink-600 dark:border-gray-800"
				>
					Follow
				</a>
			</div>
		</div>
	</div>
</template>
